import { useSelector } from 'react-redux';
import { useAllInPricingVariant, ALL_IN_PRICING_VARIANTS, } from 'hooks/use-all-in-pricing-variant';
import { SearchPageView } from 'utils/search-page-view';
import { getSearchView } from 'store/selectors/selectors';
export const useAllInPricingMobile = () => {
    const variant = useAllInPricingVariant();
    const view = useSelector(getSearchView);
    const showMobileCallout = variant === ALL_IN_PRICING_VARIANTS.ON_WITH_MARKETING &&
        view !== SearchPageView.DESKTOP_LIST;
    return {
        showMobileCallout,
    };
};
